// Libs
// Components, Layouts, Pages
// Others
import { IconSvgProps } from '~/utils/interface/common';
// Styles, images, icons

const CommonIconPlus = (props: IconSvgProps) => {
  //#region Destructuring Props
  const { width = 17, height = 17, strokePath, fill = 'none' } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <svg width={width} height={height} viewBox='0 0 17 17' fill={fill} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12.042 8.5L11.334 9.20801M12.042 8.5V9.20801M12.042 8.5V9.20801M12.042 8.5L11.334 9.20801M11.334 9.20801H9.20801V7.79199H12.042L12.1807 7.80566C12.3167 7.83291 12.4434 7.89945 12.543 7.99902C12.6757 8.13185 12.75 8.31221 12.75 8.5L12.7363 8.63867C12.7091 8.77482 12.6425 8.90133 12.543 9.00098L12.4346 9.08887C12.3191 9.1659 12.1828 9.20794 12.042 9.20801M11.334 9.20801H12.042M4.95801 8.5L5.66602 9.20801M4.95801 8.5V9.20801M4.95801 8.5L5.66602 9.20801M4.95801 8.5V9.20801M5.66602 9.20801H4.95801M5.66602 9.20801H7.79199V7.79199H4.95801L4.81934 7.80566C4.68326 7.83291 4.55661 7.89945 4.45703 7.99902C4.32429 8.13185 4.25 8.31222 4.25 8.5L4.26367 8.63867C4.29085 8.77482 4.35745 8.90133 4.45703 9.00098L4.56543 9.08887C4.68089 9.1659 4.81716 9.20794 4.95801 9.20801M8.36133 12.7363C8.27058 12.7182 8.18443 12.6822 8.10742 12.6309L7.99902 12.543C7.89945 12.4434 7.83291 12.3167 7.80566 12.1807L7.79199 12.042V4.95801C7.79208 4.77026 7.86626 4.58979 7.99902 4.45703C8.13185 4.32429 8.31222 4.25 8.5 4.25L8.63867 4.26367C8.77482 4.29085 8.90133 4.35745 9.00098 4.45703C9.13374 4.58979 9.20792 4.77026 9.20801 4.95801V12.042L9.19434 12.1807C9.16709 12.3167 9.10055 12.4434 9.00098 12.543L8.89258 12.6309C8.77711 12.7078 8.64081 12.75 8.5 12.75L8.36133 12.7363Z'
        fill={strokePath}
        stroke=''
        strokeWidth='21.3333'
      />
    </svg>
  );
};

export default CommonIconPlus;
